class DrilldownMenu extends HTMLElement {
  constructor() {
    super();
    this.stack = ['root'];
  }

  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    const trigger = event.target.closest('[data-drilldown-target]');
    if (trigger && this.contains(trigger)) {
      event.preventDefault();
      this.#goTo(trigger.getAttribute('data-drilldown-target'));
      return;
    }

    const back = event.target.closest('[data-drilldown-back]');
    if (back && this.contains(back)) {
      event.preventDefault();
      this.#goBack();
    }
  };

  #goTo(panelId) {
    const panel = this.querySelector(`[data-drilldown-panel="${panelId}"]`);
    if (!panel) return;

    panel.classList.add('is-active');
    panel.scrollTop = 0;
    this.stack.push(panelId);
  }

  #goBack() {
    if (this.stack.length <= 1) return;

    const currentId = this.stack.pop();
    const panel = this.querySelector(`[data-drilldown-panel="${currentId}"]`);
    panel?.classList.remove('is-active');
  }

  /**
   * Réinitialise la navigation sur le panneau racine.
   * Appelé à la fermeture du menu mobile.
   */
  reset() {
    this.stack = ['root'];
    this.querySelectorAll('[data-drilldown-panel]').forEach((panel) => {
      if (panel.getAttribute('data-drilldown-panel') !== 'root') {
        panel.classList.remove('is-active');
      }
    });
  }
}

if (!customElements.get('drilldown-menu')) {
  customElements.define('drilldown-menu', DrilldownMenu);
}
